(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["booking-popup"] && !Shopify.designMode) return;
  try {
    // Get all buttons with the specific class
const openButtons = document.querySelectorAll('.open-modal-btn');
const closeBtn = document.getElementById('closeModalBtn');
const overlay = document.getElementById('modalOverlay');

// Loop through each button and add the click event
openButtons.forEach(button => {
  button.addEventListener('click', () => {
    overlay.style.display = 'block';
  });
});

// Close logic remains the same
closeBtn.addEventListener('click', () => {
  overlay.style.display = 'none';
});

window.addEventListener('click', (event) => {
  if (event.target === overlay) {
    overlay.style.display = 'none';
  }
});
  } catch(e) { console.error(e); }
})();

})();
